import styled from 'styled-components';

export const ApplyBlock = styled('div')`
  height: 10%;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & .error {
    width: 20%;
    color: red;
  }
`;

export const ApplyLeftBlock = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;

  & .error {
    width: 40%;
    color: red;
  }
`;
